import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useData } from "../../context/DataContext";
import { useGo, useCurrentPage } from "../../hooks/useSiteNav";
import Nav from "./Nav";
import Footer from "./Footer";
import ScrollProgress from "../common/ScrollProgress";
import WABtn from "../widgets/WABtn";
import CallbackWidget from "../widgets/CallbackWidget";
import AIChat from "../widgets/AIChat";
import SmartSearch from "../widgets/SmartSearch";
import ExitPopup from "../widgets/ExitPopup";
import NewsletterPopup from "../widgets/NewsletterPopup";

export default function WebsiteLayout() {
  const { db, saveDB } = useData();
  const go = useGo();
  const pg = useCurrentPage();
  const navigate = useNavigate();

  const [searchOpen, setSearchOpen] = useState(false);
  const [exitShown, setExitShown] = useState(false);
  const [showExit, setShowExit] = useState(false);
  const [newsletterShown, setNewsletterShown] = useState(false);
  const [showNewsletter, setShowNewsletter] = useState(false);

  useEffect(() => {
    if (exitShown) return;
    const h = e => { if (e.clientY <= 6) { setShowExit(true); setExitShown(true); } };
    document.addEventListener("mouseleave", h);
    return () => document.removeEventListener("mouseleave", h);
  }, [exitShown]);

  useEffect(() => {
    if (newsletterShown) return;
    const t = setTimeout(() => { setShowNewsletter(true); setNewsletterShown(true); }, 25000);
    return () => clearTimeout(t);
  }, [newsletterShown]);

  const certs = db.certifications || [];

  return (
    <div style={{ background: "#F4F6FA" }}>
      <Nav pg={pg} go={go} onAdmin={() => navigate("/admin/login")} db={db} onSearch={() => setSearchOpen(true)} />
      <Outlet />
      <Footer go={go} certs={certs} db={db} />

      <WABtn num={db.settings?.waNumber} />
      <CallbackWidget />
      <AIChat />
      {searchOpen && <SmartSearch db={db} go={go} onClose={() => setSearchOpen(false)} />}
      {showExit && <ExitPopup onClose={() => setShowExit(false)} saveDB={saveDB} />}
      {showNewsletter && <NewsletterPopup onClose={() => setShowNewsletter(false)} saveDB={saveDB} />}
      <ScrollProgress />
    </div>
  );
}
